var removeDefaultTableStyles = "\n    .ads-date-picker table,\n    .ads-date-picker caption,\n    .ads-date-picker tbody,\n    .ads-date-picker tfoot,\n    .ads-date-picker thead,\n    .ads-date-picker tr,\n    .ads-date-picker th,\n    .ads-date-picker td\n    {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        outline: 0;\n        font-size: 100%;\n        vertical-align: baseline;\n        background: transparent;\n    }\n";
var dayPickerStyles = {
  root: {
    margin: '0',
    padding: '0'
  },
  daysOfTheWeek: {
    height: '100%',
    width: '100%',
    display: 'flex'
  },
  daysOfTheWeekCell: {
    width: '100%'
  },
  monthsContainer: {
    margin: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '16px',
    width: '100%'
  },
  month: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0',
    padding: '0',
    width: '100%'
  },
  monthTable: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    maxWidth: 'none'
  },
  monthTableBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    border: '0',
    gap: '8px'
  },
  daysRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignSelf: 'stretch'
  },
  dayCell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
    width: '44px',
    minHeight: '40px',
    padding: '0'
  },
  dayCellWithLabel: {
    minHeight: '40px'
  },
  mobileMonthsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '16px'
  },
  mobileMonth: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '4px',
    margin: '0',
    padding: '0'
  },
  mobileDaysOfTheWeek: {
    display: 'none'
  },
  mobileDayCell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
    minHeight: '40px',
    minWidth: '44px'
  },
  mobileDayCellWithLabel: {
    minHeight: '40px'
  }
};

export { dayPickerStyles, removeDefaultTableStyles };
//# sourceMappingURL=DatePickerStyles.js.map
